import * as v from "valibot";
import { SourcingWebsiteUrlStatus } from "@/shared/gql/graphql";

export const searchParams = v.object({
  q: v.optional(v.string()),
  status: v.optional(v.enum(SourcingWebsiteUrlStatus)),
  tenderPageFound: v.optional(v.boolean()),
  page: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
});

export type SourcingWebsitesSearch = v.InferOutput<typeof searchParams>;
